module.exports = __webpack_public_path__ + "static/media/icono_inscripcion.c70957ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icono_inscripcion.png
// module id = 815
// module chunks = 0